import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumFileUploadComponent } from './file-upload.component';

@NgModule({
  declarations: [
    CapturumFileUploadComponent
  ],
  exports: [
    CapturumFileUploadComponent
  ],
  imports: [
    CommonModule
  ]
})
export class CapturumFileUploadModule {
}
